import { AxiosInstance } from 'axios';
import { Dictionary } from '@/types';

export enum Statuses {
  CHECKED = 'checked',
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
}

export type Id = string | number;

export interface Item {
  id: Id;
  rules_issue: string;
  rules_confirm: string;
}

export interface Providers {
  $api: AxiosInstance;
  $config: Dictionary<any>;
}

export interface State {
  items: any;
  status: Statuses;
}

export interface MunicipalityId {
  id: string;
}

export type Items = Array<Item>;



// WEBPACK FOOTER //
// ./src/pages/inquiry/types.ts